import { render } from "./group-perm.vue?vue&type=template&id=5a18b6f9&scoped=true"
import script from "./group-perm.vue?vue&type=script&lang=js"
export * from "./group-perm.vue?vue&type=script&lang=js"

import "./group-perm.vue?vue&type=style&index=0&id=5a18b6f9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a18b6f9"]])

export default __exports__